import React, {useState} from 'react';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import '../css/EncyclopediaPage.css';
// import EncyclopediaPanels from '../components/EncyclopediaPanels';
import encyclopediaDefinitions from '../components/EncyclopediaDefinitions';

/**
 * @component The component renders the Encyclopedia page
 * @return {Component} EncyclopediaPage component
 */
export default function EncyclopediaPage() {
  // eslint-disable-next-line no-unused-vars
  const [searchTerm, setSearchTerm] = useState('');

  return (
    <div>
      <div className="encyclopedia-header-background" />
      <div>
        <div style={{display: 'flex', flexDirection: 'column'}}>
          <div className="encyclopedia-top">
            <br />
            <h1>AIS Corp. Encyclopedia</h1>
            <br />
            <div className="search-form">
              <form className="search-form">
                <input
                  type="text"
                  id="search"
                  onChange={(e) => {
                    setSearchTerm(e.target.value);
                  }}
                />
                <button type="submit">
                  <i className="fa fa-search"></i>
                </button>
              </form>
            </div>
          </div>
          <div className="encyclopedia-sort">
            <a href="">A</a>
            <a href="">B</a>
            <a href="">C</a>
            <a href="">D</a>
            <a href="">E</a>
            <a href="">F</a>
            <a href="">G</a>
            <a href="">H</a>
            <a href="">I</a>
            <a href="">J</a>
            <a href="">K</a>
            <a href="">L</a>
            <a href="">M</a>
            <a href="">N</a>
            <a href="">O</a>
            <a href="">P</a>
            <a href="">Q</a>
            <a href="">R</a>
            <a href="">S</a>
            <a href="">T</a>
            <a href="">U</a>
            <a href="">V</a>
            <a href="">W</a>
            <a href="">X</a>
            <a href="">Y</a>
            <a href="">Z</a>
          </div>
          {/* <div className="encyclopedia-mid">
            <div className="encyclopedia-mid-block">
              <h2>Pick of the week</h2>
              <a href="/#">
                <div className="encyclopedia-featured-post">
                  <div className="encyclopedia-ribbon">
                    <p>&nbsp;&nbsp;Term</p>
                  </div>
                </div>
              </a>
            </div>
            <div className="encyclopedia-mid-block">
              <h2>Pick of the week</h2>
              <a href="/#">
                <div className="encyclopedia-featured-post">
                  <div className="encyclopedia-ribbon">
                    <p>&nbsp;&nbsp;Resource</p>
                  </div>
                </div>
              </a>
            </div>
            <div className="encyclopedia-mid-block">
              <h2>Pick of the week</h2>
              <a href="/#">
                <div className="encyclopedia-featured-post">
                  <div className="encyclopedia-ribbon">
                    <p>&nbsp;&nbsp;Term</p>
                  </div>
                </div>
              </a>
            </div>
          </div> */}
        </div>
        <div className="encyclopedia-menu-root">
          <div className="encyclopedia-menu-container">
            <div className="encyclopedia-left-menu">
              <Card
                style={{
                  padding: '50px',
                  width: '100%',
                  height: '100%',
                }}
              >
                <Grid item xs={12} md={8}>
                  <br />
                  <br />
                  <a href="/#">Terms</a>
                  <br />
                  <br />
                  <a href="/#">Resources</a>
                  <br />
                  <br />
                </Grid>
              </Card>
            </div>
            <div className="encyclopedia-right-menu">
              <Card
                style={{
                  padding: '50px',
                  width: '100%',
                }}
              >
                {encyclopediaDefinitions
                // .filter((val) => {
                //   if (searchTerm == '') {
                //     return val;
                //   } else if (
                //     val.word.toLowerCase().includes(searchTerm.toLowerCase())
                //   ) {
                //     return val;
                //   }
                // })
                    .map((term, key) => (
                      <div key={key}>
                        <p>
                          <strong>{term.word}</strong>
                        </p>
                        <p style={{marginTop: '-5px'}}>{term.definition}</p>
                        <br />
                      </div>
                    ))}
              </Card>
            </div>
          </div>
        </div>
      </div>
      {/* <EncyclopediaPanels /> */}
    </div>
  );
}
